export default __webpack_public_path__ + "img/Inter-Black_037d78a.woff2";